import styled from 'styled-components'

export const Container = styled.div`
  .MuiFilledInput-root {
    height: 52px;
  }

  .MuiFilledInput-input {
    text-align: right;
  }

  .MuiFormHelperText-root {
    margin: ${props => props.theme.spacing.sp2} 0 0;
    color: ${props => (props.hasError ? props.theme.colors.danger.default : props.theme.colors.text.muted)};
  }

  .MuiFormHelperText-root > span {
    justify-content: flex-end;
  }
`
